import { CBadge } from './CBadge.js';

const CBadgePlugin = {
    install: (app) => {
        app.component(CBadge.name, CBadge);
    },
};

export { CBadge, CBadgePlugin };
//# sourceMappingURL=index.js.map
